import { SectionHeader } from "@/components/SectionHeader";
import { ButtonLink } from "@/components/ui/Button";

export function CtaRow({
  title,
  body,
  cta,
}: {
  title: string;
  body: string;
  cta: { label: string; href: string };
}) {
  return (
    <section className="px-8 py-20 md:px-6 md:py-32">
      <SectionHeader
        variant="split"
        align="center"
        mobileAlign="center"
        className="mx-auto max-w-6xl"
        title={title}
        body={body}
        aside={
          <ButtonLink href={cta.href} size="lg">
            {cta.label}
          </ButtonLink>
        }
      />
    </section>
  );
}
